import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { c as d } from "../../../../index-CROKJrb5.js";
import { c as m, f as p } from "../../../../create-component-CBAeEoQ6.js";
import { useBrand as u } from "../../../../brand/context/index.js";
const b = d({
  variants: {
    brand: {
      agency: "cur-border-border-subtle",
      curology: "cur-border-border-brand-light"
    },
    divider: {
      true: "cur-border-l"
    }
  }
}), x = m(
  "NavigationDropdownContent",
  p(
    ({ as: r, children: t, className: e, divider: n, ...a }, s) => {
      const c = r || "div", i = u();
      return /* @__PURE__ */ o.jsx(
        c,
        {
          as: r,
          ref: s,
          className: b({
            brand: i,
            className: e,
            divider: n
          }),
          ...a,
          children: /* @__PURE__ */ o.jsx("div", { className: "cur-flex cur-px-[2.5rem] cur-py-[3.25rem]", children: t })
        }
      );
    }
  )
);
export {
  x as NavigationDropdownContent
};
//# sourceMappingURL=index.js.map
